var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var OptionService = /** @class */ (function () {
    function OptionService(options) {
        if (options === void 0) { options = {}; }
        this.options = __assign({ allowMethodsWhenDoGet: false, views: '', disabledRoutes: [], routingErrors: {} }, options);
    }
    OptionService.prototype.get = function (key) {
        if (key === void 0) { key = null; }
        if (key) {
            return this.options[key];
        }
        return this.options;
    };
    OptionService.prototype.set = function (dataOrKey, value) {
        if (value === void 0) { value = null; }
        if (dataOrKey instanceof Object) {
            var data = dataOrKey;
            this.options = __assign({}, this.options, data);
        }
        else {
            var key = dataOrKey;
            this.options[key] = value;
        }
        return this.options;
    };
    OptionService.prototype.getAllowMethodsWhenDoGet = function () {
        return this.options.allowMethodsWhenDoGet;
    };
    OptionService.prototype.setAllowMethodsWhenDoGet = function (value) {
        this.options.allowMethodsWhenDoGet = value;
    };
    OptionService.prototype.getViews = function () {
        return this.options.views;
    };
    OptionService.prototype.setViews = function (value) {
        this.options.views = value;
    };
    OptionService.prototype.getDisabledRoutes = function () {
        return this.options.disabledRoutes;
    };
    OptionService.prototype.setDisabledRoutes = function (value, override) {
        if (override === void 0) { override = false; }
        if (override) {
            this.options.disabledRoutes = value;
        }
        else {
            this.options.disabledRoutes = this.options.disabledRoutes.concat(value);
        }
    };
    OptionService.prototype.getRoutingErrors = function () {
        return this.options.routingErrors;
    };
    OptionService.prototype.setRoutingErrors = function (value, override) {
        if (override === void 0) { override = false; }
        if (override) {
            this.options.routingErrors = value;
        }
        else {
            this.options.routingErrors = __assign({}, this.options.routingErrors, value);
        }
    };
    return OptionService;
}());
export { OptionService };
